import * as React from 'react';
import { SVGProps } from 'react';

const IconTechResponseSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
    <path d="M12.953 7.347c.027.213.047.426.047.653h-2a3 3 0 0 0-6 0H3c0-.22.02-.44.047-.653l-1.407-1.1a.329.329 0 0 1-.08-.427l1.333-2.307a.325.325 0 0 1 .407-.146l1.66.666c.347-.26.72-.486 1.127-.653l.253-1.767c.02-.16.16-.28.327-.28h2.666c.167 0 .307.12.327.28l.253 1.767c.407.167.78.387 1.127.653l1.66-.666a.335.335 0 0 1 .407.146L14.44 5.82a.336.336 0 0 1-.08.427l-1.407 1.1ZM9.5 12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM3 9h1v2.085a1.5 1.5 0 1 1-1 0V9ZM12.5 14a1.5 1.5 0 0 0 .5-2.915V9h-1v2.085A1.5 1.5 0 0 0 12.5 14Z" />
  </svg>
);
export default IconTechResponseSizeS;
